import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import PermessiSelector from './PermessiSelector';
import { DEFAULT_PERMS } from '../perms';

const inp = { padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13 };

export default function UtentiCard() {
  const [users, setUsers] = useState([]);
  const [nuovo, setNuovo] = useState({ username: '', password: '', ruolo: 'operatore', permessi: DEFAULT_PERMS });
  const [busy, setBusy] = useState(false);
  const [editUser, setEditUser] = useState(null);   // username di cui sto modificando i permessi
  const [editPerms, setEditPerms] = useState([]);

  const load = useCallback(() => {
    axios.get(`${API}/auth/users`).then((r) => setUsers(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const crea = async () => {
    setBusy(true);
    try {
      const payload = { ...nuovo };
      if (payload.ruolo === 'admin') payload.permessi = [];
      await axios.post(`${API}/auth/users`, payload);
      toast.success(`Utente "${nuovo.username}" creato`);
      setNuovo({ username: '', password: '', ruolo: 'operatore', permessi: DEFAULT_PERMS });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore creazione utente'); }
    setBusy(false);
  };

  const apriPermessi = (u) => { setEditUser(u.username); setEditPerms(u.permessi || []); };
  const salvaPermessi = async () => {
    try {
      await axios.post(`${API}/auth/users/${editUser}/permessi`, { permessi: editPerms });
      toast.success('Permessi aggiornati');
      setEditUser(null);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const resetPwd = async (u) => {
    const pwd = window.prompt(`Nuova password per "${u.username}" (min 6 caratteri):`);
    if (!pwd) return;
    try { await axios.post(`${API}/auth/users/${u.username}/password`, { password: pwd }); toast.success('Password aggiornata'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const toggle = async (u) => {
    try { await axios.post(`${API}/auth/users/${u.username}/toggle`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const elimina = async (u) => {
    if (!window.confirm(`Eliminare definitivamente l'utente "${u.username}"?`)) return;
    try { await axios.delete(`${API}/auth/users/${u.username}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  return (
    <div className="imp-card imp-card--wide">
      <div className="imp-card-title">Utenti</div>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 14 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#64748b' }}>
            <th style={{ padding: '6px 4px' }}>Utente</th>
            <th style={{ padding: '6px 4px' }}>Ruolo</th>
            <th style={{ padding: '6px 4px' }}>Stato</th>
            <th style={{ padding: '6px 4px' }}>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <React.Fragment key={u.username}>
              <tr style={{ borderTop: '1px solid #f1f5f9' }}>
                <td style={{ padding: '6px 4px', fontWeight: 600 }}>{u.username}</td>
                <td style={{ padding: '6px 4px' }}>{u.ruolo === 'admin' ? 'Amministratore' : 'Operatore'}</td>
                <td style={{ padding: '6px 4px', color: u.attivo === false ? '#b91c1c' : '#15803d' }}>
                  {u.attivo === false ? 'disattivato' : 'attivo'}
                </td>
                <td style={{ padding: '6px 4px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {u.ruolo !== 'admin' && (
                    <button className="btn btn-secondary" onClick={() => apriPermessi(u)}>Permessi</button>
                  )}
                  <button className="btn btn-secondary" onClick={() => resetPwd(u)}>Password</button>
                  <button className="btn btn-secondary" onClick={() => toggle(u)}>{u.attivo === false ? 'Attiva' : 'Disattiva'}</button>
                  <button className="btn btn-secondary" style={{ color: '#b91c1c' }} onClick={() => elimina(u)}>Elimina</button>
                </td>
              </tr>
              {editUser === u.username && (
                <tr>
                  <td colSpan={4} style={{ padding: '4px 4px 12px' }}>
                    <div className="perm-box">
                      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
                        Sezioni abilitate per <b>{u.username}</b>
                      </div>
                      <PermessiSelector value={editPerms} onChange={setEditPerms} />
                      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                        <button className="btn btn-primary" onClick={salvaPermessi}>Salva permessi</button>
                        <button className="btn btn-secondary" onClick={() => setEditUser(null)}>Annulla</button>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          {users.length === 0 && (
            <tr><td colSpan={4} style={{ padding: '8px 4px', color: '#94a3b8' }}>Nessun utente.</td></tr>
          )}
        </tbody>
      </table>

      <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Nuovo utente</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Username</label>
            <input style={inp} placeholder="username" value={nuovo.username}
                   onChange={(e) => setNuovo({ ...nuovo, username: e.target.value })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Password</label>
            <input style={inp} type="password" placeholder="min 6 caratteri" value={nuovo.password}
                   onChange={(e) => setNuovo({ ...nuovo, password: e.target.value })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <label style={{ fontSize: 11, color: '#64748b' }}>Ruolo</label>
            <select style={inp} value={nuovo.ruolo} onChange={(e) => setNuovo({ ...nuovo, ruolo: e.target.value })}>
              <option value="operatore">Operatore</option>
              <option value="admin">Amministratore</option>
            </select>
          </div>
        </div>

        {nuovo.ruolo === 'operatore' && (
          <div className="perm-box">
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>
              Sezioni abilitate per il nuovo operatore (l'amministratore vede sempre tutto):
            </div>
            <PermessiSelector value={nuovo.permessi} onChange={(p) => setNuovo({ ...nuovo, permessi: p })} />
          </div>
        )}

        <button className="btn btn-primary" style={{ marginTop: 12 }}
                disabled={busy || !nuovo.username || nuovo.password.length < 6} onClick={crea}>
          Aggiungi utente
        </button>
      </div>
    </div>
  );
}
